import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UtilityModule } from '@sb/library/utility';
import { IconBulletComponent } from './icon-bullet/icon-bullet.component';
import { IconSvgComponent } from './icon-svg/icon-svg.component';

@NgModule({
    declarations: [
        IconSvgComponent,
        IconBulletComponent
    ],
    imports: [
        CommonModule,
        MatTooltipModule,
        UtilityModule
    ],
    exports: [
        IconSvgComponent,
        IconBulletComponent
    ],
})

export class IconModule {
}
